/* eslint-disable camelcase */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import Loader from 'components/layout/Loader';
import { addSubscriptionPriceForUserR, editSubscriptionPriceForUserR } from 'actions/SubscriptionPricesActions';
import { getTimezoneFromState } from 'js/helpers/intl';
import DateTimePicker from 'components/forms/DateTimePicker';
import moment from 'moment';
import { Clearfix } from 'react-bootstrap';
import IntlDateTime from 'components/layout/IntlDateTime';
import FormSwitchery from 'components/forms/FormSwitchery';
import { getAvailableDateRange, getDateObject, getDateObjectFromDate, getPeriodStartEnd } from 'helpers/subscriptions';

class ClientSubscriptionForLoggedInUserNewAndEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getEmptyState();
  }

  getEmptyState = () => {
    const { form, subscription } = this.props;
    let startEndDate = getPeriodStartEnd(
      subscription?.period_start,
      subscription?.period_end,
      subscription?.billing_cycle
    );

    let startDate =
      getDateObjectFromDate(subscription?.activesubscriptions?.[0]?.period_start) || startEndDate.startDate;
    let endDate = getDateObjectFromDate(subscription?.activesubscriptions?.[0]?.period_end) || startEndDate.endDate;
    return {
      cancelAtPeriodEnd: subscription?.activesubscriptions?.[0]?.cancel_at_period_end,
      subStartPeriod: startDate,
      subEndPeriod: endDate,
      startDateRange: getAvailableDateRange(null, null, true, startDate, endDate, subscription),
      endDateRange: getAvailableDateRange(null, null, false, startDate, endDate, subscription),
      error: false,
    };
  };

  setNewDateTime = (name, value) => {
    let { subEndPeriod } = this.state;
    const { subscriptionId, cancelAtPeriodEnd, subStartPeriod } = this.state;
    const { subscription } = this.props;

    if (subStartPeriod < new Date() && subscription?.activesubscriptions?.[0]?.is_active) {
      return;
    }

    if (!cancelAtPeriodEnd) {
      const date = getPeriodStartEnd(
        subscription?.period_start,
        subscription?.period_end,
        subscription?.billing_cycle,
        value
      );
      subEndPeriod = date.endDate;
    }

    this.setState({
      subStartPeriod: value,
      subEndPeriod: subEndPeriod,
      startDateRange: getAvailableDateRange(
        subscriptionId,
        null,
        true,
        value,
        subEndPeriod,
        subscription,
        cancelAtPeriodEnd
      ),
      endDateRange: getAvailableDateRange(
        subscriptionId,
        null,
        false,
        value,
        subEndPeriod,
        subscription,
        cancelAtPeriodEnd
      ),
    });
  };

  setNewDateTimeUntil = (name, value) => {
    const { subscriptionId, subStartPeriod, cancelAtPeriodEnd } = this.state;
    const { subscription } = this.props;

    this.setState({
      subEndPeriod: value,
      startDateRange: getAvailableDateRange(
        subscriptionId,
        null,
        true,
        subStartPeriod,
        value,
        subscription,
        cancelAtPeriodEnd
      ),
      endDateRange: getAvailableDateRange(
        subscriptionId,
        null,
        false,
        subStartPeriod,
        value,
        subscription,
        cancelAtPeriodEnd
      ),
    });
  };

  changeCancelAtPeriodEnd = (_, cancelAtPeriodEnd) => {
    let { subStartPeriod, subEndPeriod } = this.state;
    const { subscription } = this.props;

    if (!cancelAtPeriodEnd) {
      const date = getPeriodStartEnd(
        subscription?.period_start,
        subscription?.period_end,
        subscription?.billing_cycle,
        subStartPeriod
      );
      subEndPeriod = date.endDate;
    }

    this.setState({
      subEndPeriod,
      cancelAtPeriodEnd,
      startDateRange: getAvailableDateRange(
        null,
        null,
        true,
        subStartPeriod,
        subEndPeriod,
        subscription,
        cancelAtPeriodEnd
      ),
      endDateRange: getAvailableDateRange(
        null,
        null,
        false,
        subStartPeriod,
        subEndPeriod,
        subscription,
        cancelAtPeriodEnd
      ),
    });
  };

  subscribe = () => {
    const { user, close, subscription, addSubscriptionPriceForUserR } = this.props;
    const { subStartPeriod, subEndPeriod, cancelAtPeriodEnd } = this.state;
    const data = {
      subscription: subscription?.id, // backend names the id string as "subscription"
      name: subscription?.name,
      clients: [user?.username],
      companys: [],
      clientItems: [],
      items: [],
      periodStart: subStartPeriod,
      periodEnd: subEndPeriod,
      starting_fee: subscription?.starting_fee,
      fee: subscription?.fee,
      isActive: true,
      billingTarget: '',
      cancelAtPeriodEnd: cancelAtPeriodEnd,
    };
    const start = moment(subStartPeriod);
    const end = moment(subEndPeriod);
    if (start.isAfter(end)) {
      this.setState({ error: true });
    } else {
      addSubscriptionPriceForUserR(data);
      close();
    }
  };

  extend = () => {
    const { user, close, subscription, editSubscriptionPriceForUserR } = this.props;
    const { subStartPeriod, subEndPeriod, cancelAtPeriodEnd } = this.state;
    const data = {
      subscription: subscription?.id, // backend names the id string as "subscription"
      type: subscription?.type,
      name: subscription?.name,
      clients: [user?.username],
      companys: [],
      clientItems: [],
      items: [],
      periodStart: subStartPeriod,
      periodEnd: subEndPeriod,
      starting_fee: subscription?.starting_fee,
      fee: subscription?.fee,
      isActive: true,
      billingTarget: '',
      cancelAtPeriodEnd: cancelAtPeriodEnd,
    };

    const start = moment(subStartPeriod);
    const end = moment(subEndPeriod);
    if (start.isAfter(end)) {
      this.setState({ error: true });
    } else {
      editSubscriptionPriceForUserR(subscription?.activesubscriptions?.[0]?.id, data);
      close();
    }
  };

  render() {
    const {
      intl: { messages },
      show,
      appIntl,
      close,
      defaultTimezone,
      form,
      pending,
      subscription,
    } = this.props;

    const { subStartPeriod, subEndPeriod, cancelAtPeriodEnd, error, startDateRange, endDateRange } = this.state;
    let currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const isActive = subscription?.activesubscriptions?.[0]?.is_active;
    const isStartDateChangable = !isActive || (subStartPeriod >= currentDate && isActive);
    return (
      <>
        <Modal show={show} onHide={close} bsSize="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>{messages.create_subscription}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={12}>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {messages.sub_start_end}
                  </div>
                )}
                <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm">
                  {isStartDateChangable ? (
                    <DateTimePicker
                      value={subStartPeriod}
                      label={messages.subscription_start}
                      locale={appIntl.locale}
                      minDate={startDateRange.minDate}
                      maxDate={startDateRange.maxDate}
                      displayTz={defaultTimezone}
                      onChange={this.setNewDateTime}
                    />
                  ) : (
                    <div className="form-group form-group-default">
                      <label>{messages.subscription_start}</label>
                      <div className="lh-25">
                        <Clearfix>
                          <span>
                            <IntlDateTime date={subStartPeriod} />
                          </span>
                        </Clearfix>
                      </div>
                    </div>
                  )}
                  {cancelAtPeriodEnd ? (
                    <DateTimePicker
                      value={subEndPeriod}
                      label={messages.subscription_end}
                      locale={appIntl.locale}
                      minDate={endDateRange.minDate}
                      maxDate={endDateRange.maxDate}
                      displayTz={defaultTimezone}
                      onChange={this.setNewDateTimeUntil}
                    />
                  ) : (
                    <div className="form-group form-group-default">
                      <label>{messages.subscription_end}</label>
                      <div className="lh-25">
                        <Clearfix>
                          <span>
                            <IntlDateTime date={subEndPeriod} />
                          </span>
                        </Clearfix>
                      </div>
                    </div>
                  )}
                  <div className="m-t-10 m-b-10">
                    <FormSwitchery
                      name="cancelAtPeriodEnd"
                      label={messages.period_status}
                      value
                      checked={!!cancelAtPeriodEnd}
                      onChange={this.changeCancelAtPeriodEnd}
                      disabled=""
                    />
                  </div>
                  <div className="form-group form-group-default">
                    <label>{messages.subscription_billing_period}</label>
                    <div className="lh-25">
                      <Clearfix>
                        <span>{messages[(subscription?.billing_cycle)]}</span>
                      </Clearfix>
                    </div>
                  </div>
                  {pending && <Loader />}
                  {form === 'new' ? (
                    <Button
                      onClick={() => this.subscribe()}
                      bsStyle="success"
                      className="pull-right"
                      title="activate_subscription"
                    >
                      <span className="hidden-xs">{messages.subscription_liu_send}</span>
                    </Button>
                  ) : (
                    <Button
                      onClick={() => this.extend()}
                      bsStyle="success"
                      className="pull-right"
                      title="edit_subscription"
                    >
                      <span className="hidden-xs">{messages.subscription_liu_send}</span>
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    client: state.selectedClient.company,
    subscriptionsList: state.list.subscriptions,
    defaultTimezone: getTimezoneFromState(state),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    addSubscriptionPriceForUserR: data => {
      dispatch(addSubscriptionPriceForUserR(data));
    },
    editSubscriptionPriceForUserR: (id, data) => {
      dispatch(editSubscriptionPriceForUserR(id, data));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ClientSubscriptionForLoggedInUserNewAndEdit)
  )
);
